export function isAllowListActive(drop) {
  return ['art_pass_sale','allow_list_sale'].includes(drop.status)
}

export function allowListIsNotActive(drop) {
  return !isAllowListActive(drop)
}
